import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, FileTextIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusPages, bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1ye1o3otisfy9">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1ybx8waq67uio">
        <div className="text-center" data-id="element-22" data-mp="1annwfzeukj47">
          <GiftIcon className="mx-auto h-10 w-10 text-teal" data-id="element-23" data-mp="1aop55x8e4tir" />
          <p className="mt-4 text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-24" data-mp="15q5ly4l6lvu3">Siempre incluidos · siempre gratis</p>
          <h2 id="bonus-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-25" data-mp="1jibxtehaxgnq">Los {totalBonuses} bonos estratégicos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="r082u323zwbr">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`bg-ivory flex flex-col rounded-2xl border p-6 shadow-card ${bonus.wide ? 'border-2 border-gold md:col-span-2' : 'border-line'}`} data-id="element-27" data-mp="mws7rb5ou416" data-mpi={index}>
                <span className="mb-5 flex h-10 w-10 items-center justify-center rounded-lg bg-aquaSoft text-teal" data-id="element-28" data-mp="1qvld33t3a1i3">
                  <Icon className="h-5 w-5" data-id="element-29" data-mp="20roeg7g49w3z" />
                </span>
                <p className="text-[10px] font-extrabold uppercase tracking-wider text-teal" data-id="element-30" data-mp="20q3m8oh9yp9a">Bono {bonus.number}</p>
                <h3 className="mt-2 text-xl font-bold text-ink" data-id="element-31" data-mp="25o54562ysij6">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-32" data-mp="3c6a8klchmim8">{bonus.description}</p>

                {bonus.items && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-33" data-mp="1h359ptw1enw9">
                    {bonus.items.map(item => <li key={item} className="rounded-full border border-line bg-mist px-3 py-1 text-xs font-semibold text-muted" data-id="element-34" data-mp="1c4tz3gxx49cz">
                        {item}
                      </li>)}
                  </ul>}

                {bonus.purpose && <p className="mt-4 rounded-xl border border-teal/20 bg-aquaSoft px-4 py-3 text-sm text-teal" data-id="element-35" data-mp="ycnums44nqtd">
                    Su función es <b className="font-extrabold uppercase tracking-wide" data-id="element-36" data-mp="tevtr8li8ud1">{bonus.purpose}</b>
                  </p>}

                {bonus.progression && <div className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] font-extrabold uppercase tracking-wider text-teal" data-id="element-37" data-mp="12er63gqsqven">
                    {bonus.progression.map((step, stepIndex) => <React.Fragment key={step} data-id="element-38" data-mp="ao4lkad97a08" data-mpi={stepIndex}>
                        {stepIndex > 0 && <ArrowRightIcon className="h-3 w-3 text-gold" aria-hidden="true" data-id="element-39" data-mp="jej83dxu3vh" />}
                        <span data-id="element-40" data-mp="hjxwnyr89qv">{step}</span>
                      </React.Fragment>)}
                  </div>}

                <p className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-4 text-sm" data-id="element-41" data-mp="3mrnukvr0o72d">
                  <span className="text-muted line-through" data-id="element-42" data-mp="3rq7ekqm1v8s3">Valor {bonus.value}</span>
                  <span className="flex items-center gap-3" data-id="element-43" data-mp="jb7b1uh9tj1m">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-goldSoft px-3 py-1 text-xs font-extrabold text-alert" data-id="element-44" data-mp="o8p92ptr2duu">
                      <FileTextIcon className="h-3.5 w-3.5" data-id="element-45" data-mp="9awymc328fni" /> {bonus.pages} pág.
                    </span>
                    <span className="font-extrabold text-teal" data-id="element-46" data-mp="e9864g5vue2k">GRATIS</span>
                  </span>
                </p>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-47" data-mp="2z1tgybyvieh2">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-48" data-mp="3ah6ibx8eh1fg">Total de bonos</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-49" data-mp="35hk8zyvp05bx">
            {totalBonuses} bonos <span className="mx-2 text-gold" data-id="element-50" data-mp="30kbldirrz93a">·</span> {bonusPages} páginas
          </p>
        </div>

        <p className="mx-auto mt-6 max-w-xl rounded-xl border border-teal/20 bg-aquaSoft px-5 py-4 text-center text-sm text-teal" data-id="element-51" data-mp="20lf6x2g92k9">
          Valor total de los {totalBonuses} bonos <span className="mx-1 text-muted line-through" data-id="element-52" data-mp="3o8bnfeujelx6">{bonusTotalValue}</span>
          <b className="font-extrabold" data-id="element-53" data-mp="3j9s1hefy1a4t">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}